import {createSlice} from '@reduxjs/toolkit';

import {
  builderGetReasons,
  builderGetVendorGrade,
  builderSetClose,
  builderSetOpenVendor
} from './reducer';

const initialState: any = {
  reasons: [],
  errorReason: '',
  reasonsLoading: true,
  errorSetClose: '',
  message: '',
  settingUpCloseVendor: false,
  settingUpOpenVendor: false,
  setOpenVendorMessage: '',
  setOpenVendorError: '',
  loading: 0,
  vendorGrade: {}
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builderGetReasons(builder);

    builderSetClose(builder);

    builderSetOpenVendor(builder);

    builderGetVendorGrade(builder);
  }
});

export default profileSlice.reducer;
